import { useLingui } from '@lingui/react';
import { Badge } from '@mantine/core';
export type LootBoxesTagProps = {
  tagType: 'prime-orb' | 'car' | 'orb-item' | 'phone';
};
const PrimeTag: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Badge radius={5} color="var(--bg-500)" fz={{
    base: 10,
    sm: 11
  }} c="var(--text-prime)">
      {i18n._('primeorb')}
    </Badge>;
};
const CarTag: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Badge radius={5} color="var(--text-green)" fz={{
    base: 10,
    sm: 11
  }} c="var(--bg-100)">
      {i18n._('car')}
    </Badge>;
};
const ItemTag: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Badge radius={5} color="var(--text-purple)" fz={{
    base: 10,
    sm: 11
  }} c="var(--text-white)">
      {i18n._('pr-orb item')}
    </Badge>;
};
const PhoneTag: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Badge radius={5} color="var(--text-blue)" fz={{
    base: 10,
    sm: 11
  }} c="var(--text-white)">
      {i18n._('phone')}
    </Badge>;
};
export const LootBoxesTag: React.FC<LootBoxesTagProps> = ({
  tagType
}) => {
  return <>
      {tagType === 'prime-orb' ? <PrimeTag /> : tagType === 'car' ? <CarTag /> : tagType === 'orb-item' ? <ItemTag /> : tagType === 'phone' ? <PhoneTag /> : null}
    </>;
};